// Returns minutes-since-midnight for an event time string, for sorting.
// Accepts 24-hour ("14:30", "09:00") and 12-hour ("2:30 PM", "9:00 am") formats.
// Null, undefined, empty, or unparseable input returns 0 (sorts earliest within
// the day) — matches the safe fallback in backend is_upcoming().
export function parseEventTime(timeStr) {
  if (!timeStr || typeof timeStr !== "string") return 0;
  const trimmed = timeStr.trim();
  if (!trimmed) return 0;

  // 12-hour: "h:mm AM/PM" or "hh:mm am/pm"
  const twelve = trimmed.match(/^(\d{1,2}):(\d{2})\s*(am|pm)$/i);
  if (twelve) {
    let hours = parseInt(twelve[1], 10);
    const minutes = parseInt(twelve[2], 10);
    const isPM = twelve[3].toLowerCase() === "pm";
    if (hours === 12) hours = 0;
    if (isPM) hours += 12;
    return hours * 60 + minutes;
  }

  // 24-hour: "H:mm" or "HH:mm"
  const twentyFour = trimmed.match(/^(\d{1,2}):(\d{2})$/);
  if (twentyFour) {
    const hours = parseInt(twentyFour[1], 10);
    const minutes = parseInt(twentyFour[2], 10);
    return hours * 60 + minutes;
  }

  return 0;
}
